import "./App.css";
import PDFTableComponent from "./components/PDFTableComponent";

function App() {
  return (
    <div className="App">
      <PDFTableComponent />

    </div>
  );
}

export default App;
